module.exports = __webpack_public_path__ + "static/media/16. Speaker Zulfikri Osman.d5101db4.png";